<template>
  <div>
    <the-headersider />

    <!-- Header -->
    <base-card class="header-card">
      <div class="header-row">
        <div>
          <h2 class="title">Mpesa Payments</h2>
          <p class="subtitle">
            {{ filteredPayments.length }} transactions found
          </p>
        </div>

        <!-- Inline Stats -->
        <div class="stat-pill">
          <span class="label">Total</span>
          <span class="value">{{ mpesaPayments.length }}</span>
        </div>

        <div class="stat-pill success">
          <span class="label">Processed</span>
          <span class="value">{{ processedCount }}</span>
        </div>

        <div class="stat-pill pending">
          <span class="label">Pending</span>
          <span class="value">{{ pendingCount }}</span>
        </div>

        <input
          type="search"
          class="search"
          v-model="search"
          placeholder="Search account, name or reference"
        />
      </div>
    </base-card>

    <!-- Table -->
    <base-card>
      <div v-if="loading" class="loading">
        Loading Mpesa payments...
      </div>

      <div v-else class="table-wrapper">
        <table class="table fancy-table">
          <thead>
            <tr>
              <th>Transaction Id</th>
                <th>Account No</th>

              <th>Paid By</th>
              <th>Amount</th>
              <th>Payment Date</th>
              <th>Reference</th>
              <th>Status</th>
            </tr>
          </thead>

          <tbody>
            <tr v-if="filteredPayments.length === 0">
              <td colspan="6" class="empty">No payments found</td>
            </tr>

            <tr v-for="payment in filteredPayments" :key="payment.id">
              <td>{{ payment.TransID }}</td>
                            <td>{{ payment.account_number }}</td>

              <td class="name">{{ payment.paid_by }}</td>
              <td class="amount">
                KES {{ formatAmount(payment.amount) }}
              </td>
              <td>
                {{ new Date(payment.payment_date).toLocaleString("nl-NL") }}
              </td>
              <td>{{ payment.reference }}</td>

              <!-- Clickable Status -->
              <td>
                <router-link
                  :to="`/mpesa/${payment.TransID}`"
                  class="badge-link"
                >
                  <span
                    class="badge"
                    :class="payment.processed == 1 ? 'success' : 'pending'"
                  >
                    {{ payment.processed == 1 ? "Processed" : "Pending" }}
                  </span>
                </router-link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </base-card>
  </div>
</template>

<script>
export default {
  name: "MpesaPayments",

  data() {
    return {
      mpesaPayments: [],
      search: "",
      loading: false,
    };
  },

  computed: {
    filteredPayments() {
      const key = this.search.toLowerCase();

      return this.mpesaPayments
        .slice()
        .reverse()
        .filter(p =>
          (p.account_number &&
            p.account_number.toString().includes(key)) ||
          (p.paid_by &&
            p.paid_by.toLowerCase().includes(key)) ||
          (p.reference &&
            p.reference.toLowerCase().includes(key))
        );
    },

    processedCount() {
      return this.mpesaPayments.filter(p => p.processed == 1).length;
    },

    pendingCount() {
      return this.mpesaPayments.filter(p => p.processed == 0).length;
    },
  },

  mounted() {
    this.fetchMpesaPayments();
  },

  methods: {
    async fetchMpesaPayments() {
      this.loading = true;
      try {
        const res = await fetch(
          "https://api.roberms.com/gla/get/mpesa"
        );
        const data = await res.json();

 this.mpesaPayments = data.map((p, i) => ({
  id: p.id !== undefined && p.id !== null ? p.id : i,
  paid_by: p.name,
  phone: p.phone_number,
  amount: p.amount,
  payment_date: p.payment_date,
  TransID: p.TransID,
  account_number: p.account_number,
  reference: p.payment_reference,
  processed: Number(p.processed), // 0 or 1
}));

      } catch (err) {
        console.error("Failed to load Mpesa payments", err);
      } finally {
        this.loading = false;
      }
    },

    formatAmount(val) {
      return Number(val || 0).toLocaleString();
    },
  },
};
</script>

<style scoped>
/* Header */
.header-card {
  margin-bottom: 0.75rem;
}

.header-row {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.title {
  font-size: 1.4rem;
  font-weight: 700;
}

.subtitle {
  font-size: 0.85rem;
  color: #6b7280;
}

/* Search */
.search {
  margin-left: auto;
  width: 260px;
  padding: 0.55rem 0.7rem;
  border-radius: 8px;
  border: 1px solid #d1d5db;
}

/* Stats Pills */
.stat-pill {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  padding: 0.45rem 0.8rem;
  border-radius: 999px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
}

.stat-pill .label {
  font-size: 0.7rem;
  color: #6b7280;
  text-transform: uppercase;
}

.stat-pill .value {
  font-weight: 700;
  font-size: 0.9rem;
}

.stat-pill.success {
  background: #ecfdf5;
  border-color: #a7f3d0;
  color: #065f46;
}

.stat-pill.pending {
  background: #fff7ed;
  border-color: #fed7aa;
  color: #9a3412;
}

/* Table */
.table-wrapper {
  overflow-x: auto;
}

.fancy-table th {
  background: #f9fafb;
  font-size: 0.85rem;
}

.name {
  font-weight: 600;
}

.amount {
  font-weight: 700;
}

.badge-link {
  text-decoration: none;
}

.badge {
  padding: 0.3rem 0.6rem;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 600;
}

.badge.success {
  background: #dcfce7;
  color: #166534;
}

.badge.pending {
  background: #fee2e2;
  color: #991b1b;
}

.empty,
.loading {
  text-align: center;
  padding: 1rem;
  color: #6b7280;
}
</style>
